// src/alipay-popup-sdk.js
/**
 * @author cyzhi
 * @description 支付宝停车助手插件
 * @version 1.0.0
 * @updateDate 2025.04.27 
 * 
 * @update 增加未初始化仅上报方法 uninit
 * @updateDate 2025.05.08
 * @version 1.0.1
 * 
 * @update 上报请求切换 reportActionSync
 * @updateDate 2025.05.10
 * @version 1.0.2
 * 
 * @update _visible 默认值错误
 * @updateDate 2025.06.06
 * @version 1.0.2
 * 
 * @update 返回失败，关闭广告
 * @updateDate 2025.06.24
 * @version 1.0.2
 * 
 * @update 新版停车助手，外部统一
 * @updateDate 2025.07.01
 * @version 1.0.5
 * 
 * @update 开放PID
 * @updateDate 2025.09.12
 * @version 1.0.6
 * 
 * @update 可配置支付宝参数
 * @updateDate 2025.09.12
 * @version 1.0.7
 * 
 * @changelog
 * - 1.0.7(2025.12.17)
 *  - 可配置支付宝参数
 * - 1.0.6(2025.09.12)
 * 	- 可配置PID
 * - 1.0.5(2025.07.01)
 * 	- 新版停车助手，外部统一版本号
 * - 1.0.2(2025.06.24)
 *  - 关闭广告
 * - 1.0.2(2025.06.06)
 * 	- _visible 默认值错误导致超时不返回，已修复
 * - 1.0.2(2025.05.10)
 * 	- 上报请求切换为navigator.sendBeacon，保证数据准确性
 * 
 * - 1.0.1 (2025.05.08)
 *   - 抽离 report 方法为通用函数 reportAction，实现埋点逻辑复用
 *   - 新增 SDK 方法 AlipayPopupSDK.reportUninitialized，用于未初始化场景埋点上报
 * 
 * - 1.0.0 (2025.04.27)
 *   - 初始化版本，支持插件弹窗、iframe 传参、埋点上报、loading 控制等功能
 */
function reportAction({ action, plateNo = '', platform = '', isDebug = false }) {
	const fetchApi = isDebug ? "https://api.test.aipay.cloud/api/log/ad/common"
	 : "https://api.aipay.cloud/pay/log/ad/common";
	fetch(fetchApi, {
	  method: 'POST',
	  body: JSON.stringify({
	    event: 'plugin_loaded',
	    isvNo: platform,
		adType: 3, // 类型 3 - 支付宝停车助手
		adParams: {
			action: action,
			bizKey: plateNo
		}
	  }),
	  headers: { 'Content-Type': 'application/json' }
	})
}
function reportActionSync({ action, plateNo = '', platform = '', isDebug = false }) {
	const fetchApi = isDebug ? "https://api.test.aipay.cloud/api/log/ad/common"
	 : "https://api.aipay.cloud/pay/log/ad/common";
	 if (navigator.sendBeacon) {
		 navigator.sendBeacon(fetchApi, JSON.stringify({
		    event: 'plugin_loaded',
		    isvNo: platform,
		 		adType: 3, // 类型 3 - 支付宝停车助手
		 		adParams: {
		 			action: action,
		 			bizKey: plateNo
		 		}
		  }))
	 } else {
		 fetch(fetchApi, {
		   method: 'POST',
		   body: JSON.stringify({
		     event: 'plugin_loaded',
		     isvNo: platform,
		 	adType: 3, // 类型 3 - 支付宝停车助手
		 	adParams: {
		 		action: action,
		 		bizKey: plateNo
		 	}
		   }),
		   headers: { 'Content-Type': 'application/json' },
		   keepalive: true
		 })
	 }
	 
}
class AlipayPopup extends HTMLElement {
  constructor() {
    super()
    this.attachShadow({ mode: 'open' })
    this.timer = null
    this.plateNo = ''
    this.platform = ''
	this.pid = ''
	this.applicationSign = ''
	this.invokeChannel = ''
	this.facilitator = ''
	this.showLoading = true
	this.isDebug = false
    this._visible = false
    this._iframeSrc = ''
    this._onMessage = () => {}
  }

  connectedCallback() {
    this.render()
    window.addEventListener('message', this.handleMessage.bind(this))
  }

  disconnectedCallback() {
    window.removeEventListener('message', this.handleMessage.bind(this))
  }

  open({ plateNo, platform, onMessage, showLoading, isDebug, pid, applicationSign, invokeChannel, facilitator }) {
    this.plateNo = plateNo || ''
    this.platform = platform || ''
	this.showLoading = showLoading
	this.isDebug = isDebug
	this.pid = pid || ''
	this.applicationSign = applicationSign || ''
	this.invokeChannel = invokeChannel || ''
	this.facilitator = facilitator || ''
    this._onMessage = typeof onMessage === 'function' ? onMessage : () => {}

    this._visible = false
	
    this.render()
    this.report('init')

    const param = {
      plateNo: this.plateNo,
      facilitatorPid: this.pid || "2088341863364372",
      applicationSign: this.applicationSign || "9TnFAmjTk/CjWP4gGvZXHanK/ySUG2TzFpSCAgh3HRkY8aL3m92H6zitT1BES0iK",
      invokeChannel: this.invokeChannel || "duanwai",
      facilitator: this.facilitator || "tingcheguanjia"
    }

    const encoded = encodeURIComponent(JSON.stringify(param))
    this._iframeSrc = `https://parkingzhushou.alipay-eco.com?param=${encoded}`
    this.shadowRoot.querySelector('iframe').src = this._iframeSrc

	if (this.showLoading) {
		this.shadowRoot.querySelector('.loading').classList.add('show')
	}

    this.timer = setTimeout(() => {
      if (!this._visible) {
        this._onMessage({ plateNo: this.plateNo, message: "请求超时" })
        this.hide()
      }
    }, 3000)
  }

  close() {
    this._onMessage({ plateNo: this.plateNo, message: "手动关闭" })
    this.hide()
  }

  handleMessage(evt) {
    try {
	  if (evt.data !== 'undefined') {
		const data = JSON.parse(evt.data)
		this.shadowRoot.querySelector('.loading').classList.remove('show')
		if (data.message === '插件拉起成功') {
		  this.report('pullSuccess')
		  this._visible = true
		  clearTimeout(this.timer)
				this.shadowRoot.querySelector('.popup').classList.add('show')
		} else if (data.message === '插件拉起失败') {
		  this.report('pullFail')
		  clearTimeout(this.timer)
		  this._onMessage({ plateNo: this.plateNo, message: data.message })
		  this.hide()
		} else if (data.message === '开通成功') {
		  this.report('openSuccess')
		} else if (data.message === '开通失败') {
		  this.report('openFail')
		} else if (
		  data.message === '关闭开通首页' ||
		  data.message === '关闭开通结果页' ||
		  data.message === '「我知道了」点击'
		) {
		  this._onMessage({ plateNo: this.plateNo, message: data.message })
		  this.hide()
		} else {
		  // this.hide()
		}
	  }
      
    } catch (e) {
      console.error('消息解析失败', e)
    }
  }

  hide() {
    this._visible = false
    this.shadowRoot.querySelector('.popup').classList.remove('show')
	this.shadowRoot.querySelector('.loading').classList.remove('show')
  }

  report(action) {
	  reportActionSync({
		  action: action,
		  plateNo: this.plateNo,
		  platform: this.platform,
		  isDebug: this.isDebug
	  })
  }

  render() {
    this.shadowRoot.innerHTML = `
      <style>
        .popup {
          position: fixed;
          bottom: -100%;
          left: 0;
          right: 0;
          height: 90vh;
          background: #fff;
          transition: bottom 0.3s ease;
          z-index: 9999;
        }
        .popup.show {
          bottom: 0;
        }
        .popup iframe {
          width: 100vw;
          height: 90vh;
          border: none;
        }
        .loading {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          display: none;
          align-items: center;
          justify-content: center;
          background: rgba(255, 255, 255, 0.8);
          z-index: 9998;
        }
        .loading.show {
          display: flex;
        }
        .spinner {
          width: 40px;
          height: 40px;
          border: 4px solid #ccc;
          border-top-color: #1890ff;
          border-radius: 50%;
          animation: spin 0.8s linear infinite;
        }
        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }
      </style>
      <div class="popup">
        <iframe src="${this._iframeSrc}"></iframe>
      </div>
      <div class="loading">
        <div class="spinner"></div>
      </div>
    `
  }

}

customElements.define('alipay-popup', AlipayPopup)

const AlipayPopupSDK = {
  instance: null,
  init({ plateNo, platform = '', onMessage, showLoading = true, isDebug = false, pid = '', applicationSign = '', invokeChannel = '', facilitator = '' }) {
    // 创建 dom 并挂载
    if (!this.instance) {
      const popup = document.createElement('alipay-popup')
      document.body.appendChild(popup)
      this.instance = popup
    }
    this.instance.open({ plateNo, platform, onMessage, showLoading, isDebug, pid, applicationSign, invokeChannel, facilitator })

    return {
      close: () => this.instance?.close?.()
    }
  },
  uninit({ plateNo = '', platform = '', isDebug = false}) {
	  reportActionSync({
		action: 'uninit',
		plateNo: plateNo,
		platform: platform,
		isDebug: isDebug
	  })
  }
}

window.AlipayPopupSDK = AlipayPopupSDK
